// @ts-strict-ignore
import React from "react";

import RichTextEditor, { RichTextEditorProps } from "./RichTextEditor";

interface RichTextEditorLoadingProps
  extends Omit<
    RichTextEditorProps,
    | "disabled"
    | "editorRef"
    | "onChange"
    | "defaultValue"
    | "error"
    | "helperText"
    | "label"
    | "name"
  > {
  helperText?: RichTextEditorProps["helperText"];
  label?: string;
  name?: string;
}

export const RichTextEditorLoading = (props: RichTextEditorLoadingProps) => (
  <RichTextEditor
    {...props}
    label={props.label ?? ""}
    name={props.name ?? ""}
    disabled={true}
    readOnly={true}
    error={false}
    helperText={props.helperText ?? ""}
    defaultValue={{ blocks: [] }}
    editorRef={{ current: null }}
  />
);
